import { REDUCERS } from '../../constants/reducers';

const initialState = {
  breeds: null,
  breedsError: null,
  breedsFilterOptions: [],
  breedsLoading: false,
  breedsSelectOptions: []
};

const breed = (state = initialState, action) => {
  switch (action.type) {
    case REDUCERS.BREEDS.FETCH_BREEDS_REQUEST:
      return { ...state, breedsLoading: true, breedsError: null };
    case REDUCERS.BREEDS.FETCH_BREEDS_SUCCESS:
      return { ...state, breedsLoading: false, ...action.payload };
    case REDUCERS.BREEDS.FETCH_BREEDS_FAILURE:
      return { ...state, breedsLoading: false, breedsError: action.payload };
    default:
      return state;
  }
};

export { breed };
